import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-init-draft',
  templateUrl: './init-draft.component.html',
  styleUrls: ['./init-draft.component.css']
})
export class InitDraftComponent implements OnInit {

  constructor() { }

  public ngOnInit(): void {
  }

}
